// Megamenu open/close on hover or click
const toggleMegaMenu = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const inlineMenu = document.querySelector(".header__inline-menu")
    const detailsItems = inlineMenu.querySelectorAll("details")

    const toggleMegaMenuClass = isOpen => {
      document.body.classList.toggle("mega-menu-opened", isOpen)
    }

    detailsItems.forEach(item => {
      let timeoutId

      const openMenu = () => {
        clearTimeout(timeoutId)
        item.setAttribute("open", "true")
        toggleMegaMenuClass(true)
      }

      const closeMenu = () => {
        timeoutId = setTimeout(() => {
          item.removeAttribute("open")
          toggleMegaMenuClass(false)
        }, 100)
      }

      item.addEventListener("mouseenter", openMenu)
      item.addEventListener("mouseleave", closeMenu)

      const ulElement = item.querySelector("ul")
      ulElement?.addEventListener("mouseenter", openMenu)
      ulElement?.addEventListener("mouseleave", closeMenu)
    })
  })
}
toggleMegaMenu()
